import React from "react";
import PropTypes from "prop-types";
import subscribe from "venuescanner-js/react/helpers/subscribe";
import SrpContainer from "../../containers/SrpContainer";
import { toTitleCase } from "venuescanner-js/utils/inflection";
import LocationField from "venuescanner-js/react/components/SelectField/LocationField";
import classes from "./styles.module.scss";

export const SrpNavLocationField = ({ srpContainer }) => {
  const { query, data } = srpContainer.state;
  let value = query.new_location || {
    value: query.city_slug,
    label:
      data.place_model?.title ||
      data.place_model?.name ||
      (query.city_slug && toTitleCase(query.city_slug.replace(/[-_]/g, " "))),
  };

  if (!value.value || !value.label) value = undefined;

  return (
    <LocationField
      value={value}
      containerClassName={classes.SrpNavFieldContainer}
      onChange={(val) => {
        if (val.kind === "venue") {
          if (document) document.location.assign(val.value);
          return;
        }

        srpContainer.patchQuery({
          new_location: val,
          city_slug: val.value,
          url: `/book-venue-${val.value}`,
          map_pages: [1, 2, 3],
          region: undefined,
          centre: undefined,
          page: 1,
        });
        srpContainer.refresh({ replace: true });
      }}
      clearButton={false}
    />
  );
};

SrpNavLocationField.propTypes = {
  srpContainer: PropTypes.instanceOf(SrpContainer).isRequired,
};

export default subscribe({ SrpContainer })(SrpNavLocationField);
